import { render, staticRenderFns } from "./PinRequest.vue?vue&type=template&id=1fdceb8b&scoped=true&"
import script from "./PinRequest.vue?vue&type=script&lang=js&"
export * from "./PinRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fdceb8b",
  null
  
)

export default component.exports